<div class="login-container">

  <div class="card-container" [formGroup]="form">
    <div class="title">Nouveau mot de passe</div>
    <div class="subtitle fs-14">Pour le compte {{ 'sophie.martin@novacare.com' }}
    </div>
    <div class="mt-3">
      <app-custom-input
        [required]="true"
        label="Nouveau mot de passe" [parentForm]="form" controlName="newPassword"></app-custom-input>
      <div class="text-secondary fs-11">Le mot de passe doit contenir au moins 8 caractères, dont une lettre majuscule,
        une lettre minuscule, un chiffre et un caractère spécial.
      </div>
    </div>
    <div class="mt-3">
      <app-custom-input
        [required]="true"
        label="Confirmation du nouveau mot de passe" [parentForm]="form"
        [errorMessage]="form.get('confirmPassword')?.hasError('required') ? 'Champs requis' : 'Les mots de passe saisis ne sont pas identiques.'"
        controlName="confirmPassword"></app-custom-input>
    </div>
    <app-button text="Envoyer" innerClass="mt-3 w-100" (handleClick)="changePassword()"></app-button>
    <div class="text-action cursor-pointer fs-16 mt-3" routerLink="/login">Retour à la page connexion</div>
  </div>
</div>


<div class="login-container">
  <div class="card-container">
    <svg-icon src="assets/icons/check-circle.svg"></svg-icon>
    <div class="title mt-3">Mot de passe réinitialisé</div>
    <div class="subtitle">Votre mot de passe a été réinitialisé avec succès. Vous pouvez désormais
      vous connecter avec vos nouvelles informations d'identification
    </div>
    <div class="text-action mt-3">Retour à la page connexion</div>
  </div>
</div>
